import React, { createContext, useContext } from 'react'
import { View, Text, TouchableOpacity, Image, Dimensions, Platform } from 'react-native'
import Benefits from './src/seeds/benefits.json'
import { FlashList } from '@shopify/flash-list'
import styles from './benefitsListStyles'
import BenefitContext from './BenefitContext'
import { Feather } from '@expo/vector-icons'
import theme from '../../../theme'
import { useFetchBenefits } from './hooks/useFetchBenefits'
import { placeholderGeneral } from '../customUtils/Constants'
import { Loader } from '../customUtils/Components/Loader'
import styless from './benefitsHistoryListStyles'
import styles3 from './benefitsHomeStyles3'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { LinearGradient } from 'expo-linear-gradient'
import { ScrollView } from 'react-native-gesture-handler'
import { isIOS, isAndroid } from '../../utils/platformUtils'
import { useBreakpoint } from '@/redux/zustand/useDimensionStore'

const isWeb = Platform.OS === 'web'

const BenefitItem = ({ item }) => {
    // Usamos useContext para acceder al contexto
    const handleFunctionCall = useContext(BenefitContext)

    const handleClick = () => {
        // Llamada a la función del componente abuelo
        handleFunctionCall(item)
    }

    const { languageFile } = getLanguage()

    return (
        <View style={styles.benefitsModuleList}>
            <TouchableOpacity onPress={handleClick} style={styles.benefitsContainerList}>
                <Image
                    style={[styles.benefitImage]}
                    source={{ uri: item.cover_image ? item.cover_image : placeholderGeneral }}
                    resizeMethod='resize'
                    resizeMode='contain'
                />

                <View style={styles.textBlock}>
                    <Text style={styles.title} numberOfLines={!isWeb ? 1 : 2}>
                        {item.title}
                    </Text>
                    <View style={[styles.pointsBlock]}>
                        <Text style={[styles.points, isWeb && { fontWeight: 'regular', fontSize: 16 }]}>
                            {item.points} {languageFile.points}
                        </Text>
                        <Feather name='chevron-right' size={20} color={theme.colors.colorPrimary} />
                    </View>
                </View>
            </TouchableOpacity>
        </View>
    )
}

const BenefitsList = ({ points }) => {
    const { data, isLoading, reload, fetch_data, setIsLoading } = useFetchBenefits()
    //console.log('🚀 ~ BenefitsList ~ data:', data)
    const { languageFile } = getLanguage()
    const bp = useBreakpoint()
    const columns = bp === 'sm' ? 2 : bp === 'md' ? 3 : 4
    return isLoading ? (
        <>
            <View style={{ height: 20 }} />
            <Loader />
        </>
    ) : (
        <>
            {data.length == 0 ? (
                <View style={styless.container}>
                    <Image style={styless.image} source={require('../../../assets/noBenefits.png')} />
                    <Text style={styless.title}>{languageFile.no_benefits}</Text>
                    <Text style={styless.description}>{languageFile.add_points}</Text>
                </View>
            ) : (
                <View style={styless.containerFlex}>
                    {/* <ScrollView style={styless.containerFlex}> */}
                    <FlashList
                        data={data}
                        horizontal={false}
                        keyExtractor={(item) => item._id}
                        numColumns={columns}
                        key={`columns-${columns}`}
                        showsHorizontalScrollIndicator={false}
                        renderItem={({ item: benefitItem }) => <BenefitItem item={benefitItem} />}
                    />
                    {/* </ScrollView> */}
                </View>
            )}
        </>
    )
}

export default BenefitsList
